import type { FaireProductEntity } from "../../entity_types/product";

export const p_35vp744t8l: FaireProductEntity = {
  token: "p_35vp744t8l",
  type: "product",
  name: "Hamsa Hand Evil Eye Metal Keychain: Protection & Style",
  brandToken: "b_eh970f9ptb",
  brandName: "Loli",
  imageUrl:
    "https://cdn.faire.com/fastly/6b98e875e693ad1dc47713cf63ad0f43bbe9b18bcbbb095c719a8f39b5f5f819.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ba356d6354b4491606247ff66f5a207e72ba2774985ed07f38da4cef9898a8e.jpeg",
    "https://cdn.faire.com/fastly/de4ec8d6420686772563227826c2c323f6ce0988a9197334d957377c98adb267.jpeg",
  ],
  priceDollars: 2.42,
  description:
    "Expel negative energies with our exquisite Hamsa Hand Evil Eye Keychain. This unique keychain features a stunning blue Hamsa Hand adorned with the protective evil eye symbol, believed to guard against evil spirits and bad luck. Measuring 3 inches long, it is crafted from translucent glass and metal, offering both durability and elegance.\n\nUnveiling a brilliant display of evil eyes, this keychain is not just a protective charm but also a fashionable accessory. Its compact size and striking design make it a perfect fit for everyone. As a quick seller with a great margin, it’s an ideal addition to any retail collection.\n\nThe Hamsa Hand and Evil Eye combination is a powerful symbol of protection and positivity. Whether you're looking for a thoughtful gift or a personal talisman, this keychain embodies both quality and significance. Made with premium materials, it ensures long-lasting use and a timeless appeal.\n\nCarry the protective power of the Hamsa Hand and Evil Eye wherever you go.",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:39.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
